module.exports = __webpack_public_path__ + "static/assets/33fa7e045725356aea52259539b43988.png";